import K from '../constants';
import restHelpers from '../helpers/restHelper';

const getAllConnectionRequestFn = uuid => restHelpers.withBearer.get(`${K.API_URL}/users/${uuid}/vehicles-waiting-for-payment`, {});
const deleteAConnectionRequestFn = (uuid, vehicleUuid) => restHelpers.withBearer.delete(`${K.API_URL}/users/${uuid}/vehicles/${vehicleUuid}`, {});
const getFleetCustomerDetailsFn = (uuid) => restHelpers.withBearer.get(`${K.API_URL}/users/${uuid}`, {});
const getProductsFn = () => restHelpers.withBearer.get(`${K.API_URL}/products`, {});
const getDiscountProductsFn = () => restHelpers.withBearer.get(`${K.API_URL}/discounts/products`, {});
const getVehicleInfocarDataFn = (plate) => restHelpers.withBearer.get(`${K.API_URL}/info-vehicle/get-infocar-by-plate/${plate}`, {});
const getVehicleTechnicalDetailsFn = (id) => restHelpers.withBearer.get(`${K.API_URL}/info-vehicle/get-technical-details-by-id/${id}`, {});
const getVehicleBrandsFn = () => restHelpers.withBearer.get(`${K.API_URL}/info-vehicle/brands`, {});
const getVehicleModelsByBrandIdFn = (brandId) => restHelpers.withBearer.get(`${K.API_URL}/info-vehicle/brands/${brandId}/models`, {});
const getVehicleVariantsByModelIdFn = (modelId) => restHelpers.withBearer.get(`${K.API_URL}/info-vehicle/models/${modelId}/variants`, {});
const postRegisterVehicleFn = (uuid, data) => restHelpers.withBearer.post(`${K.API_URL}/users/${uuid}/register-vehicles`, { data });
const getZuoraTokenFn = (pageId) => restHelpers.withBearer.get(`${K.API_URL}/zuora/token/${pageId}`, {});
const getZuoraPaymentMethodsFn = uuid => restHelpers.withBearer.get(`${K.API_URL}/users/${uuid}/get-zuora-payment-methods`, {});
const setPaymentMethodDefaultFn = (zuora_account_id, refId, type = 'CreditCard') => restHelpers.withBearer.post(`${K.API_URL}/zuora/default-payment-method`, {data: { zuora_account_id, refId, type }});
const getSlimpayIframeFn = (uuid) =>  restHelpers.withBearer.post(`${K.API_URL}/slimpay-order`, {data: {uuid}});
const subscribeToProductsFn = (uuid, subscriptions) => restHelpers.withBearer.post(`${K.API_URL}/zuora/fleet-customer-subscriptions`, {data: { subscriptions, uuid }});

export default {
  getAllConnectionRequest: getAllConnectionRequestFn,
  deleteAConnectionRequest: deleteAConnectionRequestFn,
  getFleetCustomerDetails: getFleetCustomerDetailsFn,
  getProducts: getProductsFn,
  getDiscountProducts: getDiscountProductsFn,
  getVehicleInfocarData: getVehicleInfocarDataFn,
  getVehicleTechnicalDetails: getVehicleTechnicalDetailsFn,
  getVehicleBrands: getVehicleBrandsFn,
  getVehicleModelsByBrandId: getVehicleModelsByBrandIdFn,
  getVehicleVariantsByModelId: getVehicleVariantsByModelIdFn,
  postRegisterVehicle: postRegisterVehicleFn,
  getZuoraToken: getZuoraTokenFn,
  getZuoraPaymentMethods: getZuoraPaymentMethodsFn,
  setPaymentMethodDefault: setPaymentMethodDefaultFn,
  getSlimpayIframe: getSlimpayIframeFn,
  subscribeToProducts: subscribeToProductsFn
};



// WEBPACK FOOTER //
// ./src/services/connectionRequests.js